// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css"); */

#POC {}



.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, .125);
  border-radius: 0.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0,0,0,.03);
  border-bottom: 1px solid rgba(0,0,0,.125);
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.mb-4, .my-4 {
  margin-bottom: 1.5rem!important;
}

.mt-4, .my-4 {
  margin-top: 1.5rem!important;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  max-width: 100%;
/*  */
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}


.col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.check-box{
  display: flex;
  justify-content: center;
}
.planA{
  margin-right: 4px;
}
.planA label{
  margin-right: 4px;
  cursor: pointer;
}

.check-box label{
  margin-right: 4px;
  cursor: pointer;

}
.check-box input{
  cursor: pointer;

}

.planB{
  margin-left: 7px;
}
.session-btn-div{
  display: flex;
  align-items: center;
}
.session-msg{
  margin-left: 10px;

}

.session-msg p{
color: blue;
}
.text-center{
  text-align: center;
}
@media (min-width: 768px){
.col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9 {
    float: left;
}
}

@media (min-width: 576px) {
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (min-width: 992px){
.container, .container-lg, .container-md, .container-sm {
    max-width: 960px;
}
}
@media (min-width: 1200px){
.container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1140px;
}
}
`, "",{"version":3,"sources":["webpack://./src/app/poc/poc.component.css"],"names":[],"mappings":"AAAA,4FAA4F;;AAE5F,MAAM;;;;AAIN;EACE,kBAAkB;EAElB,aAAa;EAEb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,0DAA0D;AAC5D;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EAEE,aAAa;EAEb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB,KAAK;AACL;;AAEA;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EAEb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;;AAEjB;AACA;EACE,eAAe;;AAEjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;;AAEnB;;AAEA;AACA,WAAW;AACX;AACA;EACE,kBAAkB;AACpB;AACA;AACA;IACI,WAAW;AACf;AACA;;AAEA;EACE;IAEE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;AACA;IACI,gBAAgB;AACpB;AACA;AACA;AACA;IACI,iBAAiB;AACrB;AACA","sourcesContent":["/* @import url(\"https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css\"); */\r\n\r\n#POC {}\r\n\r\n\r\n\r\n.card {\r\n  position: relative;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: border-box;\r\n  border: 1px solid rgba(0, 0, 0, .125);\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.card-header {\r\n  padding: 0.75rem 1.25rem;\r\n  margin-bottom: 0;\r\n  background-color: rgba(0,0,0,.03);\r\n  border-bottom: 1px solid rgba(0,0,0,.125);\r\n}\r\n\r\n.card-header:first-child {\r\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\r\n}\r\n.mb-4, .my-4 {\r\n  margin-bottom: 1.5rem!important;\r\n}\r\n\r\n.mt-4, .my-4 {\r\n  margin-top: 1.5rem!important;\r\n}\r\n\r\n.form-row {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  margin-right: -5px;\r\n  margin-left: -5px;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  margin-bottom: 1rem;\r\n  color: #212529;\r\n  max-width: 100%;\r\n/*  */\r\n}\r\n\r\n.card-body {\r\n  -ms-flex: 1 1 auto;\r\n  flex: 1 1 auto;\r\n  min-height: 1px;\r\n  padding: 1.25rem;\r\n}\r\n\r\n.row {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n  margin-right: -15px;\r\n  margin-left: -15px;\r\n}\r\n\r\n\r\n.col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.check-box{\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.planA{\r\n  margin-right: 4px;\r\n}\r\n.planA label{\r\n  margin-right: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.check-box label{\r\n  margin-right: 4px;\r\n  cursor: pointer;\r\n\r\n}\r\n.check-box input{\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.planB{\r\n  margin-left: 7px;\r\n}\r\n.session-btn-div{\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.session-msg{\r\n  margin-left: 10px;\r\n\r\n}\r\n\r\n.session-msg p{\r\ncolor: blue;\r\n}\r\n.text-center{\r\n  text-align: center;\r\n}\r\n@media (min-width: 768px){\r\n.col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9 {\r\n    float: left;\r\n}\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .col-sm-12 {\r\n    -ms-flex: 0 0 100%;\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px){\r\n.container, .container-lg, .container-md, .container-sm {\r\n    max-width: 960px;\r\n}\r\n}\r\n@media (min-width: 1200px){\r\n.container, .container-lg, .container-md, .container-sm, .container-xl {\r\n    max-width: 1140px;\r\n}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
